/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Partnerconnectedperson2Inputs */

const de__field_partnerconnectedperson2 = /** @type {(inputs: _Field_Partnerconnectedperson2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verknüpfte Person`)
};

/**

* @param {_Field_Partnerconnectedperson2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_partnerconnectedperson2 = /** @type {((inputs?: _Field_Partnerconnectedperson2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Partnerconnectedperson2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_partnerconnectedperson2(inputs)
});
export { _field_partnerconnectedperson2 as "_field_partnerConnectedPerson" }